<!--
 * @Description: 海报模板01
 * @Author: xiawenlong
 * @Date: 2021-10-14 10:08:27
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-02-16 14:09:49
-->
<template>
  <div ref="app" :class="['template01', { border: isBorder }]">
    <div class="text">
      <el-input
        v-model="contentData.title"
        :rows="2"
        resize="none"
        type="textarea"
        class="title"
      ></el-input>
      <el-input v-model="contentData.teacher" class="teacher"></el-input>
      <div class="content">
        <div v-for="(item, index) in contentData.content" :key="index" class="content-item">
          <span>{{ index + 1 }}</span>
          <el-input v-model="item.text" class="content-text"></el-input>
        </div>
      </div>
      <el-input v-model="contentData.date" class="date"></el-input>
      <div class="qrcode">
        <div class="code">
          <img :src="qrCode" alt="" />
        </div>
        <div class="des">
          <p>保存图片或</p>
          <p>用微信扫一扫识别二维码</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'Template01',
  props: {
    qrCode: {
      type: String,
      default: '',
    },
    templateBackground: {
      type: String,
      default: '',
    },
    isBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      contentData: {
        title: '企业如何\n做好生产与管理？',
        teacher: '某老师',
        content: [
          { text: '意志培训的形式' },
          { text: '意志培训的权利' },
          { text: '意志培训的主体' },
          { text: '意志培训的权利' },
        ],
        date: '2021.06.03 — 2021.06.06',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      const $app = this.$refs.app
      const standardScale = 2208 / 1242
      window.addEventListener(
        'resize',
        _.debounce(() => {
          const docHeight = document.querySelector('.design-wrapper').clientHeight
          const docWidth = document.querySelector('.design-wrapper').clientWidth

          const currentScale = docHeight / docWidth
          let [scale, translate] = [0, 0]
          if (currentScale < standardScale) {
            // 以高度计算
            scale = docHeight / 2208
            const shouleWidth = 1242 * scale
            const offsetWidth = docWidth - shouleWidth
            translate = offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : ''
          } else {
            // 以宽度计算
            scale = docWidth / 1242
            const shouleHeight = 2208 * scale
            const offsetHeight = docHeight - shouleHeight
            translate = offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : ''
          }
          console.log(translate)
          // background:url(${this.templateBackground});
          $app.style.cssText = `
            transform: scale(${scale});
            min-width: 1242px;
            min-height: 2208px;
          `
        }),
        200,
      )

      if (document.createEvent) {
        var event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      } else if (document.createEventObject) {
        window.fireEvent('onresize')
      }
    })
  },
}
</script>
<style lang="scss" scoped>
@font-face {
  font-family: Alibaba-PuHuiTi-Bold;
  src: url('../../../../../font/Alibaba-PuHuiTi-Bold.otf');
}
@font-face {
  font-family: Source Han Sans CN-Medium;
  src: url('../../../../../font/SourceHanSansCN-Medium.otf');
}
@font-face {
  font-family: Source Han Sans CN-Regular;
  src: url('../../../../../font/SourceHanSansCN-Regular.otf');
}
.template01 {
  overflow: hidden;
  position: relative;
  min-width: 1242px;
  min-height: 2208px;
  background: url('../../../../../assets/posterTemplate/template01.png') no-repeat;
  background-size: 100% 100%;
  .text {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    ::v-deep.el-input {
      input {
        vertical-align: top;
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        height: auto;
        background-color: transparent;
        color: #ffffff;
      }
    }
    ::v-deep.el-textarea {
      textarea {
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        height: auto;
        background-color: transparent;
        color: #ffffff;
      }
    }
    ::v-deep.title {
      position: absolute;
      top: 108px;
      left: 50%;
      transform: translateX(-460px);
      display: block;
      width: 960px;
      // height: 273px;
      textarea {
        padding: 0;
        height: 295px;
        font-size: 118px;
        box-sizing: border-box;
        font-family: Alibaba-PuHuiTi-Bold;
        font-weight: 700;
        line-height: 138px;
        overflow: hidden;
        text-align: center;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep.teacher {
      position: absolute;
      top: 721px;
      left: 50%;
      transform: translateX(-450px);
      display: block;
      width: 900px;
      input {
        width: 900px;
        box-sizing: border-box;
        font-family: Source Han Sans CN-Medium;
        font-size: 72px;
        font-weight: 500;
        color: #001c66;
        height: 72px;
        text-align: center;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep .content {
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      top: 1067px;
      left: 161px;
      width: 1000px;
      .content-item {
        display: flex;
        align-items: center;
        margin-right: 60px;
        margin-bottom: 42px;
        &:nth-of-type(2n) {
          margin-right: 0;
        }
        span {
          display: block;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          line-height: 60px;
          background: #1831bd;
          font-size: 42px;
          font-family: Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          margin-right: 1px;
        }
        .content-text {
          width: 375px;
          input {
            box-sizing: border-box;
            font-size: 48px;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            color: #001c66;
            &:focus {
              border: 2px dashed #ff7b33;
              border-radius: 0;
            }
          }
        }
      }
    }
    ::v-deep.date {
      position: absolute;
      top: 1507px;
      left: 50%;
      transform: translateX(-480px);
      display: block;
      width: 940px;
      input {
        height: 60px;
        font-size: 28px;
        font-weight: 500;
        color: #001c66;
        font-size: 60px;
        text-align: center;
        font-family: Source Han Sans CN-Medium;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    .qrcode {
      position: absolute;
      top: 1829px;
      left: 138px;
      display: flex;
      align-items: center;
      .code {
        width: 298px;
        height: 298px;
        background: #ffffff;
        border: 8px solid #2b65ff;
        border-radius: 10px;
        margin-right: 40px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .des {
        font-size: 52px;
        font-family: Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        line-height: 72px;
      }
    }
  }
  &.border {
    ::v-deep.el-input {
      input {
        border: 2px dashed #c9c9c9;
      }
    }
    ::v-deep.el-textarea {
      textarea {
        border: 2px dashed #c9c9c9;
      }
    }
  }
  img {
    height: 100%;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
    pointer-events: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}
</style>
